
import { useSelector } from 'react-redux'
import { selectCanAccess } from '../app/auth.js'
import { Navigate } from 'react-router-dom';


function NewOrtho(){
  const canAccess = useSelector(selectCanAccess)
  // page only for admins
  if (!canAccess('MissionsPage')) {
    return <Navigate to="/" replace />;
  }


  return <div class="container">
    <h1>Import new orthophoto</h1>
    <form>
      <div>
        <label>Name</label>
        <input type="text"/>      
      </div>
      <div>
        <label>MaxZoom</label>
        <input type="number"/>
      </div>
      <div>
        <label>Width (X) in pixels</label>
        <input type="number"/>      
      </div>
      <div>
        <label>Height (Y) in pixels</label>
        <input type="number"/>      
      </div>
      <div>
        <label>
          <p>URL, replace s3 by the proxy url, for instance instead of :</p>
          <code>{"s3://mybucket/path/of/the/tiles/{x}_{y}_{z}.jpg"}</code>
          <p>write : </p>
          <code>{"https://orthophoto-viewer-backend.herokuapp.com/proxy/mybucket/path/of/the/tiles/{x}_{y}_{z}.jpg"}</code>
        </label>
        <input type="text"/>      
      </div>
      <div>
        <label>
          <p>References for measurement : </p>
          <table>
            <tr>
              <th></th>
              <th>Position in pixel</th>
              <th>Position in unit</th>
              <th>unit</th>
            </tr>
            <tr>
              <td>X1</td>
              <td><input type="number"/></td>
              <td><input type="number"/></td>
              <td><input type="text" value="m"/></td>
            </tr>
            <tr>
              <td>X2</td>
              <td><input type="number"/></td>
              <td><input type="number"/></td>
              <td>(same unit)</td>
            </tr>
            <tr>
              <td>Y1</td>
              <td><input type="number"/></td>
              <td><input type="number"/></td>
              <td><input type="text" value="m"/></td>
            </tr>
            <tr>
              <td>Y2</td>
              <td><input type="number"/></td>
              <td><input type="number"/></td>
              <td>(same unit)</td>
            </tr>
            <p>Rappel : depuis un fichier tfw, on retrouve sur les différentes lignes : </p>
            <code>
              0.0010053922868000   // taille du pixel en X
              0
              0
              -0.0010053922868000  // taille du pixel en Y
              112.3545294          // Coordonnées en X du pixel en haut
              5.024436287          // Coordonnées en Y du pixel en haut
            </code>
          </table>
        </label>        
      </div>
    </form>
  </div>
}

export default NewOrtho